// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17QqV","colBig":"styles_colBig__2EJOT","colSmall":"styles_colSmall__Qug36"};